import { useApi } from "@kamae-apps/shared/Hooks/useApi"

class CompanyService {
  displayRankings(): boolean {
    const { data: hideRankings, isLoading } = useApi<string | null>("/company/config/HIDE_RANKINGS", {})
    return !isLoading && hideRankings !== "true"
  }
}

export const companyService = new CompanyService()
Object.freeze(companyService)
